module.exports = __webpack_public_path__ + "img/minus.6214402e.svg";